import http from '@/util/http.js'

/**
 * 单个文件上传
 * @param {} data
 * @returns
 */
function upload(data, url) {
  return http({
    url: url || '/common/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

function uploadFile(file, url) {
  let formData = new FormData()
  formData.append('file', file)
  return upload(formData, url)
}

function uploadBpmnXMLFile(formData) {
  // const blob = new Blob([fileData], {
  //   type: 'application/xml;charset=utf-8',
  // })
  // const file = new File([blob], fileName)
  // let formData = new FormData()
  // formData.append('file', file)
  return upload(formData)
}

function getAreaList(query) {
  return http({
    url: '/common/getAreaList',
    method: 'get',
    params: query
  })
}

/**
 * 上传仓库文件
 * @param {*} fileData 文件数据内容
 */
function uploadWarehouseFile(fileData, fileName) {
  const blob = new Blob([JSON.stringify(fileData)], {
    type: 'application/json;charset=utf-8'
  })
  const file = new File([blob], fileName)
  let formData = new FormData()
  formData.append('file', file)
  formData.append('disabledModify', true)
  return upload(formData)
}

export default {
  upload,
  uploadFile,
  getAreaList,
  uploadWarehouseFile,
  uploadBpmnXMLFile
}
